import CNPJValidator from './CNPJValidator'
import CPFValidator from './CPFValidator'
import IntervalFormatter from './IntervalFormatter'
import IntervalValidation from './IntervalValidation'
import PasswordValidador from './PasswordValidator'
import formatCNPJ from './CNPJformatter'


function removeSpecialCharacters(str) {
    // Regular expression to capture all special characters
    const regex = /[^\w]/g

    // Replaces all special characters with an empty string
    return str.replace(regex, '')
}

export {
    CPFValidator,
    CNPJValidator,
    PasswordValidador,
    IntervalFormatter,
    IntervalValidation,
    removeSpecialCharacters,
    formatCNPJ
}
